function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect } from "react";
import { Container, Row, Col } from 'react-bootstrap';
import { Tabs, message, Skeleton, Button, Descriptions, Space, Form, Drawer, Breadcrumb, Typography, Dropdown, Result, Image, Modal, DatePicker, Divider, Tag, Input, notification } from 'antd';
import { Table } from 'react-bootstrap';
import { ListUl, Search as SearchIcon, GraphUpArrow, HourglassSplit, Upload as UploadIc, PencilSquare, ImageFill, EyeFill, ThreeDotsVertical } from "react-bootstrap-icons";
import Common from "../components/includes/Common";
import Moment from 'react-moment';
import SetImResult from "../components/forms/SetImResult";
import SetImFile from "../components/forms/SetImFile";
import DocViewer, { DocViewerRenderers } from "@cyntler/react-doc-viewer";
import { Parser } from 'html-to-react';
import SearchActivity from "../components/SearchActivity";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var Text = Typography.Text;
var Search = Input.Search;
var RangePicker = DatePicker.RangePicker;
var Cardiologie = function Cardiologie() {
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    currentDept = _useState2[0],
    setCurrentDept = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    deptList = _useState4[0],
    setDeptList = _useState4[1];
  var _useState5 = useState(true),
    _useState6 = _slicedToArray(_useState5, 2),
    isDeptDataLoading = _useState6[0],
    setIsDeptDataLoading = _useState6[1];
  var _useState7 = useState([]),
    _useState8 = _slicedToArray(_useState7, 2),
    queueData = _useState8[0],
    setQueueData = _useState8[1];
  var _useState9 = useState(null),
    _useState0 = _slicedToArray(_useState9, 2),
    currentQueueItem = _useState0[0],
    setCurrentQueueItem = _useState0[1];
  var _useState1 = useState(''),
    _useState10 = _slicedToArray(_useState1, 2),
    searchId = _useState10[0],
    setSearchId = _useState10[1];
  var _useState11 = useState(false),
    _useState12 = _slicedToArray(_useState11, 2),
    dataChanged = _useState12[0],
    setDataChanged = _useState12[1];
  var _useState13 = useState(false),
    _useState14 = _slicedToArray(_useState13, 2),
    showTranslate = _useState14[0],
    setShowTranslate = _useState14[1];
  var _useState15 = useState(false),
    _useState16 = _slicedToArray(_useState15, 2),
    showImageInput = _useState16[0],
    setShowImageInput = _useState16[1];
  var _useState17 = useState(null),
    _useState18 = _slicedToArray(_useState17, 2),
    selectedItem = _useState18[0],
    setSelectedItem = _useState18[1];
  var _useState19 = useState(null),
    _useState20 = _slicedToArray(_useState19, 2),
    selectedQueueElement = _useState20[0],
    setSelectedQueueElement = _useState20[1];
  var _useState21 = useState(false),
    _useState22 = _slicedToArray(_useState21, 2),
    showResult = _useState22[0],
    setShowResult = _useState22[1];
  var onSearch = function onSearch(v) {
    setSearchId('');
    if (v.length > 0) {
      setSearchId(v);
      //setIsPatientModalOpen(true); 
    }
  };
  var onSelectPeriodFinish = function onSelectPeriodFinish(values) {};
  useEffect(function () {
    setDataChanged(false);
    axios.get(Common.baseApiUrl + "getdepartments").then(function (response) {
      if (response.data.status == 200) {
        setDeptList(response.data.departments);
        var dep;
        dep = response.data.departments.filter(function (d) {
          return d.dcode == 'CAR';
        });

        //let dep = response.data.departments.filter(d => d.dcode == 'CON');    
        var req;
        if (dep.length == 1) {
          setCurrentDept(dep[0]);
          req = Common.baseApiUrl + "getdailyqueue/" + dep[0].id.toString() + "/" + Common.currentUser.id;
        }
        if (dep.length == 2) {
          setCurrentDept(dep[0]);
          req = Common.baseApiUrl + "getdailyqueue/" + dep[0].id.toString() + "," + dep[1].id.toString() + "/" + Common.currentUser.id;
        }
        axios.get(req).then(function (qresponse) {
          setQueueData(qresponse.data.queueItems);
          console.log(qresponse.data.queueData);
        })["catch"](function (error) {
          message.error({
            content: error.toString(),
            delay: 4
          });
        })["finally"](function () {
          setIsDeptDataLoading(false);
        });
      }
    })["catch"](function (error) {
      message.error({
        content: error.toString(),
        delay: 4
      });
    })["finally"](function () {});
  }, [dataChanged]);
  useEffect(function () {
    setInterval(function () {
      setDataChanged(true);
    }, 30000);
  }, []);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx(Row, {
        children: /*#__PURE__*/_jsxs(Col, {
          lg: 12,
          md: 12,
          children: [/*#__PURE__*/_jsxs(Breadcrumb, {
            children: [/*#__PURE__*/_jsx(Breadcrumb.Item, {
              children: "Traitement"
            }), /*#__PURE__*/_jsx(Breadcrumb.Item, {
              children: /*#__PURE__*/_jsx("a", {
                href: "#",
                children: "Cardiologie"
              })
            })]
          }), /*#__PURE__*/_jsxs(Tabs, {
            animated: true,
            defaultActiveKey: 1,
            children: [/*#__PURE__*/_jsx(Tabs.TabPane, {
              tab: /*#__PURE__*/_jsxs("b", {
                children: [/*#__PURE__*/_jsx(ImageFill, {
                  size: 35
                }), " Attente images"]
              }),
              children: /*#__PURE__*/_jsxs("div", {
                className: "white-bg cool-radius",
                children: [/*#__PURE__*/_jsxs(Table, {
                  bordered: true,
                  responsive: true,
                  children: [/*#__PURE__*/_jsx("thead", {
                    children: /*#__PURE__*/_jsxs("tr", {
                      children: [/*#__PURE__*/_jsx("td", {
                        children: "Date"
                      }), /*#__PURE__*/_jsx("td", {
                        children: "Num. Salle"
                      }), /*#__PURE__*/_jsx("td", {
                        children: "Code P."
                      }), /*#__PURE__*/_jsx("td", {
                        children: "Nom"
                      }), /*#__PURE__*/_jsx("td", {
                        children: "Telephone"
                      }), /*#__PURE__*/_jsx("td", {
                        children: "Acte"
                      })]
                    })
                  }), /*#__PURE__*/_jsx("tbody", {
                    children: queueData.length > 0 && queueData.filter(function (qd) {
                      return qd.status == 0;
                    }).map(function (q) {
                      return /*#__PURE__*/_jsxs("tr", {
                        children: [/*#__PURE__*/_jsx("td", {
                          children: /*#__PURE__*/_jsx(Moment, {
                            format: "DD/MM/YYYY HH:mm",
                            children: q.created_at
                          })
                        }), /*#__PURE__*/_jsx("td", {
                          children: /*#__PURE__*/_jsx(Space, {
                            direction: "horizontal",
                            children: q.queue_item_elements && q.queue_item_elements.map(function (e) {
                              return /*#__PURE__*/_jsx("div", {
                                children: e.im_result != null && /*#__PURE__*/_jsx(Tag, {
                                  color: "#f50",
                                  children: /*#__PURE__*/_jsx("b", {
                                    children: e.im_result.translator.nickname
                                  })
                                })
                              }, e.id);
                            })
                          })
                        }), /*#__PURE__*/_jsx("td", {
                          children: q.customer.idnumber
                        }), /*#__PURE__*/_jsx("td", {
                          children: q.customer.firstname + " " + q.customer.lastname
                        }), /*#__PURE__*/_jsx("td", {
                          children: q.customer.mobile.toString().slice(3)
                        }), /*#__PURE__*/_jsx("td", {
                          children: /*#__PURE__*/_jsx(Space, {
                            direction: "horizontal",
                            children: q.queue_item_elements && q.queue_item_elements.map(function (e) {
                              return /*#__PURE__*/_jsx(Dropdown, {
                                placement: "bottomLeft",
                                menu: {
                                  items: [{
                                    key: '1' + e.id,
                                    label: /*#__PURE__*/_jsxs(Button, {
                                      type: "default",
                                      onClick: function onClick() {
                                        setCurrentQueueItem(q);
                                        setSelectedQueueElement(e);
                                        setShowResult(true);
                                        setSelectedItem(e.business_account_medical_item);
                                      },
                                      children: [/*#__PURE__*/_jsx(EyeFill, {
                                        size: 18
                                      }), " VOIR"]
                                    })
                                  }, {
                                    key: '2' + e.id,
                                    label: /*#__PURE__*/_jsxs(Button, {
                                      type: "default",
                                      onClick: function onClick() {
                                        setCurrentQueueItem(q);
                                        setSelectedQueueElement(e);
                                        setShowImageInput(true);
                                        setSelectedItem(e.business_account_medical_item);
                                      },
                                      children: [/*#__PURE__*/_jsx(ImageFill, {
                                        size: 18
                                      }), " EDITER IMAGE"]
                                    })
                                  }]
                                },
                                children: /*#__PURE__*/_jsxs(Space, {
                                  children: [/*#__PURE__*/_jsx(ThreeDotsVertical, {
                                    size: 15
                                  }), /*#__PURE__*/_jsx(Tag, {
                                    color: "#f50",
                                    children: e.business_account_medical_item.label
                                  })]
                                })
                              });
                            })
                          })
                        })]
                      }, "q" + q.id);
                    })
                  })]
                }), /*#__PURE__*/_jsx("br", {}), isDeptDataLoading && /*#__PURE__*/_jsx(Skeleton, {
                  active: true
                })]
              })
            }, 1), /*#__PURE__*/_jsx(Tabs.TabPane, {
              tab: /*#__PURE__*/_jsxs("b", {
                children: [/*#__PURE__*/_jsx(ListUl, {
                  size: 35
                }), " Attente interpretation"]
              }),
              children: /*#__PURE__*/_jsxs("div", {
                className: "white-bg cool-radius",
                children: [/*#__PURE__*/_jsxs(Table, {
                  bordered: true,
                  responsive: true,
                  children: [/*#__PURE__*/_jsx("thead", {
                    children: /*#__PURE__*/_jsxs("tr", {
                      children: [/*#__PURE__*/_jsx("td", {
                        children: "Date"
                      }), /*#__PURE__*/_jsx("td", {
                        children: "Num. Salle"
                      }), /*#__PURE__*/_jsx("td", {
                        children: "Code P."
                      }), /*#__PURE__*/_jsx("td", {
                        children: "Nom"
                      }), /*#__PURE__*/_jsx("td", {
                        children: "Telephone"
                      }), /*#__PURE__*/_jsx("td", {
                        children: "Acte"
                      })]
                    })
                  }), /*#__PURE__*/_jsx("tbody", {
                    children: queueData.length > 0 && queueData.filter(function (qd) {
                      return qd.status == 0;
                    }).map(function (q) {
                      return /*#__PURE__*/_jsxs("tr", {
                        children: [/*#__PURE__*/_jsx("td", {
                          children: /*#__PURE__*/_jsx(Moment, {
                            format: "DD/MM/YYYY HH:mm",
                            children: q.created_at
                          })
                        }), /*#__PURE__*/_jsx("td", {
                          children: /*#__PURE__*/_jsx(Space, {
                            direction: "horizontal",
                            children: q.queue_item_elements && q.queue_item_elements.map(function (e) {
                              return /*#__PURE__*/_jsx("div", {
                                children: e.im_result != null && /*#__PURE__*/_jsx(Tag, {
                                  color: "#f50",
                                  children: /*#__PURE__*/_jsx("b", {
                                    children: e.im_result.translator.nickname
                                  })
                                })
                              }, e.id);
                            })
                          })
                        }), /*#__PURE__*/_jsx("td", {
                          children: q.customer.idnumber
                        }), /*#__PURE__*/_jsx("td", {
                          children: q.customer.firstname + " " + q.customer.lastname
                        }), /*#__PURE__*/_jsx("td", {
                          children: q.customer.mobile.toString().slice(3)
                        }), /*#__PURE__*/_jsx("td", {
                          children: /*#__PURE__*/_jsx(Space, {
                            direction: "horizontal",
                            children: q.queue_item_elements && q.queue_item_elements.map(function (e) {
                              return /*#__PURE__*/_jsx(Dropdown, {
                                placement: "bottomLeft",
                                menu: {
                                  items: [{
                                    key: '1' + q.id,
                                    label: /*#__PURE__*/_jsx(Button, {
                                      type: "default",
                                      onClick: function onClick() {
                                        setCurrentQueueItem(q);
                                        setShowResult(true);
                                        setSelectedQueueElement(e);
                                        setSelectedItem(e.business_account_medical_item);
                                      },
                                      children: /*#__PURE__*/_jsxs("b", {
                                        children: [/*#__PURE__*/_jsx(EyeFill, {
                                          size: 18
                                        }), " VOIR"]
                                      })
                                    })
                                  }, {
                                    key: '2' + q.id,
                                    label: /*#__PURE__*/_jsx(Button, {
                                      type: "default",
                                      onClick: function onClick() {
                                        setCurrentQueueItem(q);
                                        setShowTranslate(true);
                                        setSelectedQueueElement(e);
                                        setSelectedItem(e.business_account_medical_item);
                                      },
                                      children: /*#__PURE__*/_jsxs("b", {
                                        children: [/*#__PURE__*/_jsx(PencilSquare, {
                                          size: 18
                                        }), " EDITER INTERPRETATION"]
                                      })
                                    })
                                  }]
                                },
                                children: /*#__PURE__*/_jsxs(Space, {
                                  children: [/*#__PURE__*/_jsx(ThreeDotsVertical, {
                                    size: 15
                                  }), /*#__PURE__*/_jsx(Tag, {
                                    color: "#f50",
                                    children: e.business_account_medical_item.label
                                  })]
                                })
                              });
                            })
                          })
                        })]
                      }, "d" + q.id);
                    })
                  })]
                }), /*#__PURE__*/_jsx("br", {}), isDeptDataLoading && /*#__PURE__*/_jsx(Skeleton, {
                  active: true
                })]
              })
            }, 2), /*#__PURE__*/_jsx(Tabs.TabPane, {
              tab: /*#__PURE__*/_jsxs("b", {
                children: [/*#__PURE__*/_jsx(HourglassSplit, {
                  size: 35
                }), " Historique"]
              }),
              children: /*#__PURE__*/_jsxs("div", {
                className: "white-bg cool-radius",
                children: [/*#__PURE__*/_jsxs(Table, {
                  bordered: true,
                  responsive: true,
                  children: [/*#__PURE__*/_jsx("thead", {
                    children: /*#__PURE__*/_jsxs("tr", {
                      children: [/*#__PURE__*/_jsx("td", {
                        children: "Date"
                      }), /*#__PURE__*/_jsx("td", {
                        children: "Num. Salle"
                      }), /*#__PURE__*/_jsx("td", {
                        children: "Code P."
                      }), /*#__PURE__*/_jsx("td", {
                        children: "Nom"
                      }), /*#__PURE__*/_jsx("td", {
                        children: "Telephone"
                      }), /*#__PURE__*/_jsx("td", {
                        children: "Acte"
                      })]
                    })
                  }), /*#__PURE__*/_jsx("tbody", {
                    children: queueData.length > 0 && queueData.filter(function (qd) {
                      return qd.status == 1;
                    }).map(function (q) {
                      return /*#__PURE__*/_jsxs("tr", {
                        children: [/*#__PURE__*/_jsx("td", {
                          children: /*#__PURE__*/_jsx(Moment, {
                            format: "DD/MM/YYYY HH:mm",
                            children: q.created_at
                          })
                        }), /*#__PURE__*/_jsx("td", {
                          children: q.queue_item_elements && q.queue_item_elements.map(function (e) {
                            return /*#__PURE__*/_jsx("div", {
                              children: e.im_result != null && /*#__PURE__*/_jsx(Tag, {
                                color: "#f50",
                                children: /*#__PURE__*/_jsx("b", {
                                  children: e.im_result.translator.nickname
                                })
                              })
                            }, e.id);
                          })
                        }), /*#__PURE__*/_jsx("td", {
                          children: q.customer.idnumber
                        }), /*#__PURE__*/_jsx("td", {
                          children: q.customer.firstname + " " + q.customer.lastname
                        }), /*#__PURE__*/_jsx("td", {
                          children: q.customer.mobile.toString().slice(3)
                        }), /*#__PURE__*/_jsx("td", {
                          children: /*#__PURE__*/_jsx(Space, {
                            direction: "horizontal",
                            children: q.queue_item_elements && q.queue_item_elements.map(function (e) {
                              return /*#__PURE__*/_jsx(Dropdown, {
                                placement: "bottomLeft",
                                menu: {
                                  items: [{
                                    key: '1' + e.id,
                                    label: /*#__PURE__*/_jsx(Button, {
                                      type: "default",
                                      onClick: function onClick() {
                                        setCurrentQueueItem(q);
                                        setShowResult(true);
                                        setSelectedQueueElement(e);
                                        setSelectedItem(e.business_account_medical_item);
                                      },
                                      children: /*#__PURE__*/_jsxs("b", {
                                        children: [/*#__PURE__*/_jsx(EyeFill, {
                                          size: 18
                                        }), " VOIR"]
                                      })
                                    })
                                  }, {
                                    key: '2' + e.id,
                                    label: /*#__PURE__*/_jsx(Button, {
                                      type: "default",
                                      onClick: function onClick() {
                                        setCurrentQueueItem(q);
                                        setShowTranslate(true);
                                        setSelectedQueueElement(e);
                                        setSelectedItem(e.business_account_medical_item);
                                      },
                                      children: /*#__PURE__*/_jsxs("b", {
                                        children: [/*#__PURE__*/_jsx(PencilSquare, {
                                          size: 20
                                        }), " EDITER INTERPRETATION"]
                                      })
                                    })
                                  }, {
                                    key: '2' + e.id,
                                    label: /*#__PURE__*/_jsx(Button, {
                                      type: "default",
                                      onClick: function onClick() {
                                        setCurrentQueueItem(q);
                                        setShowImageInput(true);
                                        setSelectedQueueElement(e);
                                        setSelectedItem(e.business_account_medical_item);
                                      },
                                      children: /*#__PURE__*/_jsxs("b", {
                                        children: [/*#__PURE__*/_jsx(ImageFill, {
                                          size: 18
                                        }), " EDITER IMAGE"]
                                      })
                                    })
                                  }]
                                },
                                children: /*#__PURE__*/_jsxs(Space, {
                                  children: [/*#__PURE__*/_jsx(ThreeDotsVertical, {
                                    size: 15
                                  }), /*#__PURE__*/_jsx(Tag, {
                                    color: "#f50",
                                    children: e.business_account_medical_item.label
                                  })]
                                })
                              });
                            })
                          })
                        })]
                      }, "h" + q.id);
                    })
                  })]
                }), /*#__PURE__*/_jsx("br", {}), isDeptDataLoading && /*#__PURE__*/_jsx(Skeleton, {
                  active: true
                })]
              })
            }, 3), /*#__PURE__*/_jsx(Tabs.TabPane, {
              tab: /*#__PURE__*/_jsxs("b", {
                children: [/*#__PURE__*/_jsx(GraphUpArrow, {
                  size: 35
                }), " Activit\xE9s"]
              }),
              children: /*#__PURE__*/_jsx("div", {
                className: "cool-radius white-bg",
                style: {
                  minHeight: '300px'
                },
                children: currentDept && /*#__PURE__*/_jsx(SearchActivity, {
                  dcode: currentDept.dcode
                })
              })
            }, 5)]
          })]
        })
      })
    }), currentQueueItem && currentQueueItem.customer && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Modal, {
        title: /*#__PURE__*/_jsx("b", {
          children: "INTERPRETATION"
        }),
        destroyOnClose: true,
        width: "80%",
        open: showTranslate,
        onCancel: function onCancel() {
          setShowTranslate(false);
        },
        footer: null,
        children: /*#__PURE__*/_jsx(SetImResult, {
          im_type: "cardiologie",
          q_item: currentQueueItem,
          m_item: selectedItem,
          handler: function handler() {
            setShowTranslate(false);
            setDataChanged(true);
            notification.success({
              message: "Ok!",
              description: "Données enregistrée"
            });
          }
        })
      }), /*#__PURE__*/_jsx(Modal, {
        title: /*#__PURE__*/_jsx("b", {
          children: "SAUVEGARDER LE CLICHET"
        }),
        destroyOnClose: true,
        width: "80%",
        open: showImageInput,
        onCancel: function onCancel() {
          setShowImageInput(false);
        },
        footer: null,
        children: /*#__PURE__*/_jsx(SetImFile, {
          im_type: "cardiologie",
          q_item: currentQueueItem,
          m_item: selectedItem,
          handler: function handler() {
            setShowImageInput(false);
            setDataChanged(true);
            notification.success({
              message: "Ok!",
              description: "Données enregistrée"
            });
          }
        })
      }), selectedQueueElement && selectedQueueElement.im_result && /*#__PURE__*/_jsx(Drawer, {
        title: /*#__PURE__*/_jsx("b", {
          children: "RESULTAT DE CARDIOLOGIE"
        }),
        destroyOnClose: true,
        width: "95%",
        open: showResult,
        onClose: function onClose() {
          setShowResult(false);
        },
        children: /*#__PURE__*/_jsx(Container, {
          children: /*#__PURE__*/_jsxs(Row, {
            children: [/*#__PURE__*/_jsx(Col, {
              lg: 8,
              md: 8,
              sm: 12,
              children: selectedQueueElement.im_result.file != null ? /*#__PURE__*/_jsx(Image, {
                src: Common.baseUrl + selectedQueueElement.im_result.file
              }) : /*#__PURE__*/_jsx(Result, {
                status: "404",
                title: "404",
                subTitle: "AUCUNE IMAGE CHARGEE",
                extra: /*#__PURE__*/_jsx(Button, {
                  onClick: function onClick() {
                    setShowResult(false);
                  },
                  type: "primary",
                  children: /*#__PURE__*/_jsx("b", {
                    children: "FERMER"
                  })
                })
              })
            }), /*#__PURE__*/_jsxs(Col, {
              lg: 4,
              md: 4,
              sm: 12,
              children: [/*#__PURE__*/_jsxs(Descriptions, {
                bordered: true,
                stripped: true,
                column: 1,
                title: /*#__PURE__*/_jsx("b", {
                  children: "INFOS PATIENT"
                }),
                children: [/*#__PURE__*/_jsx(Descriptions.Item, {
                  label: /*#__PURE__*/_jsx("b", {
                    children: "ID PATIENT"
                  }),
                  children: currentQueueItem.customer.idnumber
                }), /*#__PURE__*/_jsx(Descriptions.Item, {
                  label: /*#__PURE__*/_jsx("b", {
                    children: "NOM PATIENT"
                  }),
                  children: currentQueueItem.customer.firstname + " " + currentQueueItem.customer.lastname
                }), /*#__PURE__*/_jsx(Descriptions.Item, {
                  label: /*#__PURE__*/_jsx("b", {
                    children: "TEL. :"
                  }),
                  children: currentQueueItem.customer.mobile.toString().slice(3)
                })]
              }), /*#__PURE__*/_jsx(Divider, {}), selectedQueueElement.im_result.interpretation && selectedQueueElement.im_result.interpretation.length > 0 && /*#__PURE__*/_jsx("div", {
                children: Parser().parse(selectedQueueElement.im_result.interpretation)
              })]
            })]
          })
        })
      })]
    })]
  });
};
export default Cardiologie;